import { CxEvent } from '@spartacus/core';

export class Ga4GgDownloadEvent extends CxEvent {
  event?: string;
}
